// Создает URLSearchParams из объекта
export const buildSearchParams = (obj: Record<string, any>): URLSearchParams => {
  const params: URLSearchParams = new URLSearchParams();

  Object.entries(obj).forEach(([key, value]) => {
    if (Array.isArray(value)) {
      value.forEach((v) => params.append(key, v));
    } else {
      params.set(key, value);
    }
  });

  return params;
};
